import React, { FunctionComponent } from 'react'
import { Box, SxStyleProp } from 'theme-ui'

interface IReefProps {
  /** Theme UI JSX pragma */
  sx?: SxStyleProp
}

export const Reef: FunctionComponent<IReefProps> = ({ sx }) => {
  return (
    <Box sx={{ margin: '0 auto', ...sx }}>
      <svg version="1.0" x="0px" y="0px" viewBox="0 0 134 114" width="100%" height="100%">
        <g>
          <g>
            <path
              fill="#009169"
              d="M47,63.7c-2.1,0-4.3-0.2-6.3,0c-0.7,0.1-0.8,0.8-0.4,1.1c-0.1,0-0.3,0-0.4,0c-2.3-0.1-4.6-0.2-6.9-0.3
			c-2.1-0.1-4.2-0.2-6.2,0.7c-1.5,0.6-2.8,1.8-3.3,3.4c-0.5,1.7,0.1,3.6,1.3,4.9c0.8,0.9,1.9,1.5,3,1.9c2.7,2.1,6.7,2.3,9.5,0.2
			c1.2-0.4,2.4-0.9,3.5-1.5c3.4-2.1,5.9-5.6,6.8-9.5C47.8,64.1,47.5,63.7,47,63.7z"
            />
            <g>
              <path
                d="M53.7,59.4c0.6-1.3,0-1-1,0.1c-1.1,1.1-3,2.9-5.4,4.5c-2.4,1.6-5.3,2.9-7.9,3.7c-2.6,0.8-4.9,1.1-6,1.4
				c-1.1,0.3-0.3,0.6,1.6,0.6c1.9,0,4.8-0.4,7.7-1.5c2.9-1.1,5.7-3,7.7-4.8C52.3,61.6,53.5,59.9,53.7,59.4z"
              />
            </g>
            <g>
              <path
                d="M52,61.4c0.7-0.8,1.1-1.4,1.2-1.7c0.1-0.3,0.1-0.5-0.2-0.4c-0.5,0.2-1.7,1.2-3.7,2.1c-1,0.5-2.2,0.9-3.6,1.1
				c-1.4,0.2-3,0.2-4.8,0.1c-1.8-0.1-3.7-0.5-5.9-0.7c-2.1-0.2-4.5-0.4-7,0.1c-1.2,0.2-2.5,0.7-3.8,1.4c-1.2,0.7-2.3,1.9-2.9,3.3
				c-0.6,1.4-0.7,3-0.4,4.4c0.3,1.4,0.9,2.7,1.7,3.8c0.8,1.1,1.9,2.1,3,2.8c1.1,0.7,2.4,1.2,3.6,1.4c2.5,0.6,5,0.4,7.2-0.3
				c2.2-0.6,4.2-1.7,5.7-3c1.6-1.3,2.7-2.7,3.7-4.1c1.8-2.8,2.7-5.2,3-6.8c0.3-1.6,0.1-1.9-0.4-1.1c-0.5,0.7-1.4,2.4-2.9,4.6
				c-1.5,2.1-3.6,4.7-6.8,6.5c-1.5,0.8-3.4,1.4-5.3,1.6c-1.9,0.2-3.9-0.2-5.6-1.1c-0.4-0.2-0.8-0.5-1.2-0.8c-0.4-0.3-0.7-0.6-1-1
				c-0.6-0.7-1.1-1.6-1.4-2.5c-0.3-0.9-0.3-1.8-0.1-2.6c0.2-0.8,0.6-1.5,1.4-2.1c1.4-1.2,3.5-1.6,5.5-1.7c2-0.1,4.1,0.1,6.1,0.2
				c2,0.2,3.9,0.3,5.6,0.2c1.8-0.1,3.4-0.4,4.7-0.8C49.9,63.3,51.4,61.9,52,61.4z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#009169"
              d="M94.8,85.1c-2.5-2.2-5.4-3.8-8.2-5.4c-5.7-3.3-13.3-7-13.6-14.3c0-0.5,0.4-1.6,0-1.6c-0.1,0-0.1,0-0.2,0
			c-0.1,0-1.1-0.3-1.2-0.2c-2,1.6-3.6,2.7-5.9,3.8c-2.3,1.1-4.5,2.6-6.9,3.3c-2.4,0.7-5.3,0.6-7.5,1.8c-2,1.1-3.6,3.5-4.5,5.7
			c-0.9,2.1-0.2,4.3,1.2,5.9c1.6,1.7,4,2.5,6.3,2.3c2.6-0.2,5-1.3,7.2-2.7c1.9-1.2,3.7-2.7,5.3-4.4c2.1-2.3,3.8-4.9,5-7.7
			c-0.7,5,0.1,10.1,2.1,14.8c0.7,1.6,1.4,3.1,2.2,4.6c0.7,1.5,1.5,2.9,2.6,4.2c1.7,2,4,3.4,6.6,4c2.5,0.5,5.2,0.4,7.5-0.6
			c2.5-1,5.1-3.1,5.6-5.8C99,89.9,97,87.1,94.8,85.1z"
            />
            <path
              fill="#009169"
              d="M70.3,85.6c0.1-0.1,0.2-0.2,0.2-0.4c0.1-1-0.8-1.5-1-2.5c-0.2-1-0.4-1.5-0.6-2.5c-0.1-0.5-0.1-1.7-0.5-1.3
			c-2.9,3.4-6,6.7-9.3,9.7C58.1,89.3,57,90,56,90.7c-2.3,1.6-4.6,3.3-6.5,5.2c-1.7,1.8-3.1,4-3.2,6.5c-0.1,2.4,0.9,4.6,3,5.8
			c2.2,1.2,4.8,1.1,7.1,0.2c4.6-1.7,8.7-5.4,11.2-9.6C69.9,95,71,90.2,70.3,85.6z"
            />
            <g>
              <path
                d="M74.2,27.5c-0.8-3.3-0.8-2-0.5,2c0.2,2,0.4,4.7,0.7,7.8c0.2,3.1,0.5,6.7,0.6,10.3c0,1.8-0.1,3.7-0.4,5.6
				c-0.3,1.9-0.7,3.7-1.3,5.5c-1.2,3.6-3,7-4.9,9.8c-3.9,5.8-8.3,9.7-10.1,11.6c-0.9,1-1,1.2-0.3,0.8c0.6-0.4,2-1.3,3.7-2.9
				c1.7-1.5,3.9-3.6,6-6.2c2.1-2.6,4.2-5.8,5.8-9.4c1.6-3.6,2.6-7.6,2.9-11.4c0.2-3.9-0.1-7.6-0.4-10.9
				C75.3,33.7,74.5,28.8,74.2,27.5z"
              />
            </g>
            <g>
              <path
                d="M72.2,61.9C72.1,61.9,72.1,62,72,62c-0.1,0.6-0.2,1.3-0.3,2.1c-0.2,1-0.4,2.2-0.6,3.4c-0.5,2.4-1.1,5.2-1.9,8
				c-1.6,5.7-4.2,11.7-6.8,16.6c-2.6,4.9-5.4,8.7-6.5,10.5c-1.1,1.8,0.1,0.8,2.5-2.1c2.3-2.9,5.6-7.7,8.2-13.3
				c2.6-5.6,4.5-11.9,5.4-17.1c0.7-3.9,0.9-7.2,1-9C72.7,61.5,72.4,61.7,72.2,61.9z"
              />
            </g>
            <g>
              <path
                d="M73,65.4c-1.3-3.8-0.7,3.3,2.3,11.6c1.5,4.2,3.8,8.6,6.7,11.7c1.4,1.5,2.9,2.8,4.3,3.6c1.3,0.8,2.5,1.3,3.3,1.5
				c0.8,0.2,0.9,0.1,0.6-0.2c-0.3-0.3-1.1-0.7-2.2-1.5c-1-0.7-2.3-1.8-3.6-3.1c-1.3-1.3-2.6-3-3.8-4.8c-2.3-3.7-4-8.1-5.3-11.7
				C74,68.9,73.3,66.1,73,65.4z"
              />
            </g>
            <g>
              <path
                d="M71.8,63.8c0.7-0.9,1-1.5,1.2-1.9c0.1-0.4,0.1-0.5-0.2-0.4c-0.5,0.2-1.7,1.4-3.8,2.7c-2.1,1.3-5.2,2.7-9,3.7
				c-1.9,0.6-3.9,1-6.3,1.6c-2.3,0.7-4.9,1.7-6.9,4c-1,1.1-1.7,2.6-1.9,4.2c-0.2,1.6,0.1,3.2,0.7,4.6c0.6,1.4,1.6,2.6,2.8,3.6
				c1.2,1,2.7,1.6,4.1,1.9c2.9,0.6,5.8,0,8.2-1.2c2.4-1.2,4.3-3,5.9-4.9c3-3.8,4.8-7.7,5.9-11.1c1.1-3.4,1.4-6.2,1.4-7.9
				c0-1.8-0.3-2-0.6-1.1c-0.4,0.9-0.8,2.9-1.8,5.6c-1,2.7-2.4,6.1-4.7,9.5c-1.1,1.7-2.5,3.4-4.1,4.9c-1.6,1.4-3.5,2.6-5.6,3
				c-2.1,0.5-4.4,0.3-6.1-0.8c-1.7-1.1-2.9-3.1-3-5c0-1,0.2-1.9,0.8-2.7c0.5-0.8,1.3-1.6,2.2-2.1c1.7-1.2,3.9-1.8,5.9-2.4
				c4.1-1.2,7.8-2.6,10.3-4.1C69.8,66,71.3,64.5,71.8,63.8z"
              />
            </g>
            <g>
              <path
                d="M65.1,82.9c1.2-2,1.3-2.8,0.8-2.4c-0.5,0.3-1.6,1.6-3.6,3.4c-1.9,1.8-4.7,3.9-8.1,6.2c-1.7,1.2-3.7,2.4-5.5,4.2
				c-1.8,1.7-3.6,4.2-4.1,7.1c-0.3,1.5-0.3,3.1,0.2,4.6c0.3,0.8,0.6,1.5,1.1,2.2c0.5,0.7,1.1,1.2,1.7,1.7c2.5,1.9,5.9,2.5,8.8,1.7
				c2.9-0.7,5.3-2.4,7.3-4.3c1.9-1.9,3.4-4,4.6-6.2c2.3-4.4,3.1-8.9,3-12.6c-0.1-3.7-1-6.5-1.8-8.1c-0.8-1.6-1.2-1.7-1.1-0.7
				c0.1,1,0.6,3,0.7,5.9c0.1,2.9-0.3,6.6-1.7,10.5c-0.7,1.9-1.8,3.9-3.1,5.8c-1.3,1.8-2.9,3.6-4.9,4.9c-1.9,1.3-4.1,2.1-6.3,1.9
				c-2.2-0.2-4.3-1.3-5.2-3.1c-0.9-1.8-0.7-4.1,0.3-6.1c0.9-1.9,2.5-3.5,4.1-4.9c1.6-1.4,3.4-2.6,4.8-3.8c1.5-1.2,2.8-2.3,3.9-3.4
				C63.4,85.4,64.6,83.7,65.1,82.9z"
              />
            </g>
            <g>
              <path
                d="M73.3,70.7c-0.1-2.5-0.3-3.4-0.6-2.8c-0.3,0.6-0.7,2.6-1,5.6c-0.2,3.1-0.2,7.2,0.7,12c0.5,2.4,1.2,4.9,2.6,7.4
				c1.3,2.5,3.2,4.9,5.8,6.7c2.6,1.8,5.9,2.8,9.2,2.5c1.6-0.2,3.3-0.6,4.8-1.5c1.5-0.8,2.8-2.1,3.7-3.5c0.9-1.4,1.4-3.1,1.6-4.8
				c0-0.8,0-1.7-0.2-2.5c-0.2-0.8-0.5-1.6-0.9-2.4c-0.8-1.5-2-2.6-3.1-3.5c-1.2-0.9-2.4-1.6-3.5-2.3c-2.3-1.3-4.6-2.4-6.6-3.6
				c-2-1.1-3.9-2.3-5.4-3.5c-3.1-2.4-5-5-6-6.8c-0.5-0.9-0.8-1.4-1-1.6c-0.2-0.1-0.2,0.1-0.2,0.7c0.1,1.2,0.9,3.9,3.2,6.7
				c1.1,1.4,2.6,2.9,4.4,4.3c1.8,1.4,3.8,2.6,6,3.9c2.1,1.3,4.5,2.5,6.5,4c2,1.5,3.6,3.3,3.6,5.6c0.1,2.3-1.1,4.7-3,6.1
				c-2,1.4-4.6,1.9-7.1,1.4c-2.5-0.4-4.7-1.8-6.5-3.6c-1.8-1.8-3.1-3.9-4-6c-1.8-4.3-2.3-8.7-2.7-11.9C73.4,74,73.4,71.7,73.3,70.7z
				"
              />
            </g>
          </g>
          <g>
            <path
              fill="#009169"
              d="M117.5,27.9c-1.9-1.2-4.4-1.5-6.4-0.4c-2.1,1.2-3.1,3.5-4.3,5.4c-3,4.6-7.4,8-12.4,10.2
			c-0.7,0.3-0.2,1.4,0.5,1.2c0,0,0,0,0,0c1.5,1.7,3.7,2.6,5.9,2.9c2.5,0.4,5,0.3,7.5,0c4.8-0.7,9.6-3.1,11.8-7.6
			C122.1,35.7,121.4,30.4,117.5,27.9z"
            />
            <g>
              <path
                d="M74.3,26.7c-0.5-1.4-0.7-1.8-0.8-1.4c0,0.4,0.1,1.5,0.6,3.2c0.5,1.7,1.5,3.9,3.1,6.1c1.7,2.2,3.9,4.5,6.8,6.2
				c1.4,0.9,3,1.6,4.6,2.1c1.6,0.6,3.4,0.9,5.1,1c1.7,0.1,3.4,0.1,5.1-0.2c1.7-0.2,3.2-0.7,4.7-1.2c2.9-1.1,5.3-2.7,7-4.2
				c1.7-1.6,2.8-3.1,3.4-4.1c0.5-1,0.5-1.2,0.1-0.8c-0.5,0.4-1.3,1.5-2.7,2.8c-1.4,1.3-3.4,2.7-5.8,3.9c-2.5,1.2-5.5,2.1-8.6,2.2
				c-3.2,0.2-6.5-0.4-9.4-1.6c-1.5-0.6-2.8-1.4-4.1-2.2c-0.6-0.4-1.2-0.9-1.8-1.3c-0.5-0.5-1.1-0.9-1.6-1.4c-1.9-2-3.3-4-4.2-5.7
				C75,28.5,74.6,27.3,74.3,26.7z"
              />
            </g>
            <g>
              <path
                d="M94.7,42c-0.9,0.5-1.5,0.9-1.8,1.1c-0.3,0.2-0.3,0.4,0,0.4c0.6,0.1,2.3-0.2,4.7-1.3c2.4-1.1,5.5-3.2,8-6.5
				c1.3-1.7,2.2-3.7,3.3-5.4c0.6-0.8,1.1-1.6,1.8-2.2c0.7-0.6,1.5-1.1,2.3-1.3c0.8-0.2,1.5-0.1,2.4,0.2c0.8,0.3,1.6,1,2.2,1.7
				c1.3,1.5,2,3.6,2,5.6c0,2.1-0.7,4.1-2,5.6c-1.4,1.5-3.3,2.6-5.2,3.6c-3.8,1.9-7.6,2.7-10.8,2.4c-3.2-0.3-5.7-1.5-7.1-2.4
				c-1.5-0.9-1.8-1-1.3-0.1c0.5,0.9,2.2,2.6,5.1,3.8c1.5,0.6,3.2,1,5.2,1.1c2,0.1,4.1-0.2,6.2-0.8c2.1-0.6,4.3-1.5,6.4-2.7
				c1.1-0.6,2.1-1.3,3.1-2.2c1-0.9,1.9-2.1,2.4-3.3c1.2-2.5,1.4-5.5,0.7-8.1c-0.7-2.7-2.4-5.2-4.9-6.6c-1.2-0.7-2.7-1.1-4.2-0.9
				c-1.5,0.2-2.7,0.8-3.8,1.6c-1,0.8-1.8,1.8-2.5,2.7c-0.6,1-1.2,1.9-1.6,2.9c-0.9,1.9-1.8,3.4-2.9,4.7c-1.1,1.3-2.2,2.4-3.2,3.3
				C97.2,40.7,95.4,41.6,94.7,42z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M17.4,30.2c0.9-0.8,0.5-1.3-1-1.3c-1.4,0-3.9,0.9-5.7,3c-0.9,1-1.7,2.3-2.1,3.6c-0.4,1.3-0.6,2.7-0.4,4
				c0.2,2.5,1.5,4.2,2.4,4.6c2,0.7-0.2-2.5,0.7-6.6c0.4-2,1.6-3.9,3-5.2C15.6,31.1,17,30.5,17.4,30.2z"
              />
            </g>
            <g>
              <path
                d="M4.7,39.5c-0.4-0.7-0.9-0.8-1.5-0.1c-0.5,0.7-0.9,2.2-0.6,3.7C3,44.6,4,46.2,5.2,47c1.2,0.8,2.5,0.9,3.1,0.4
				c0.6-0.5,0.4-0.9,0.1-1.4c-0.4-0.5-1.1-1-1.7-1.8c-0.6-0.8-1.2-1.8-1.4-2.7C5,40.6,4.9,39.8,4.7,39.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M124.6,23.7c-1.3-0.2-1.2,0.5-0.5,1.5c0.6,1,1.7,2.7,2.2,4.8c0.6,2.1,0.6,4.5,0.2,6.7c-0.4,2.2-1.1,4-1.1,5.1
				c0,1.1,0.7,0.9,1.8-0.4c1.1-1.3,2.3-3.7,2.6-6.6c0.2-1.4,0.1-2.9-0.3-4.3c-0.3-1.4-0.9-2.7-1.6-3.7
				C126.7,24.7,125.1,23.8,124.6,23.7z"
              />
            </g>
            <g>
              <path
                d="M131.3,39.4c-0.6-0.5-1.1-0.3-1.5,0.1c-0.4,0.5-0.7,1.2-1,2.1c-0.3,0.9-0.6,1.8-0.9,2.7c-0.2,0.9-0.4,1.8-0.3,2.6
				c0.2,0.8,0.6,0.9,1.3,0.5c0.7-0.4,1.4-1.3,2-2.4c0.5-1.1,0.8-2.4,0.8-3.5C131.7,40.4,131.5,39.6,131.3,39.4z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#F30202"
              d="M70.9,22.4c-1.5-1.4-2.5-3.4-3.5-5.2c-1-1.9-2-3.8-3.1-5.6c-2.2-3.6-5.5-6.9-9.9-7.3
			c-3.9-0.4-8,2.3-8.5,6.3c-0.5,4.4,3.4,8.1,6.9,10.1c4.5,2.6,9.8,3.9,14.8,4.7c0.8,0.1,1.6-0.1,2.1-0.7
			C70.9,25,71.9,23.3,70.9,22.4z"
            />
            <path
              fill="#F30202"
              d="M102.1,10.6c0.5-3-0.1-6.3-3.2-7.6c-3.3-1.5-6.7,0.1-9,2.5c-2.4,1.4-4.5,3.8-6,5.9c-1.3,1.9-2.2,4-3.2,6
			c-0.9,1.8-2,3.7-3.8,4.9c-1,0.6-0.6,2.2,0.4,2.4c0.3,0.5,0.9,0.8,1.5,0.8c4.5-0.1,9-1.3,13-3.3c2-1,4-2.2,5.7-3.6
			c1.7-1.3,3.6-2.7,4.4-4.9C102.3,12.7,102.3,11.6,102.1,10.6z"
            />
            <g>
              <path
                d="M70.8,23.1c0.9,0.7,1.5,1,1.9,1.1c0.4,0.1,0.5,0,0.4-0.2c-0.2-0.5-1.4-1.6-2.7-3.6c-0.7-1-1.4-2.2-2.1-3.6
				c-0.8-1.4-1.5-3.1-2.5-4.8c-1-1.8-2.2-3.7-3.8-5.4c-0.8-0.9-1.8-1.7-2.9-2.4c-1.1-0.7-2.4-1.2-3.7-1.5c-1.3-0.3-2.8-0.4-4.2-0.2
				c-1.4,0.2-2.9,0.8-4.1,1.8c-1.2,1-2.1,2.3-2.6,3.7c-0.5,1.4-0.7,2.8-0.6,4.3c0.2,2.9,1.6,5.4,3.3,7.3c1.7,1.9,3.7,3.3,5.8,4.5
				c4.1,2.2,8.4,2.9,11.8,2.8c3.5-0.1,6.1-0.9,7.6-1.7c1.5-0.8,1.5-1.1,0.6-1.1c-0.9,0.1-2.8,0.5-5.5,0.6c-2.7,0.1-6.2-0.2-9.8-1.6
				c-1.8-0.7-3.6-1.7-5.3-2.9c-1.7-1.3-3.2-2.8-4.2-4.6c-0.5-0.9-0.9-1.9-1-2.9c-0.2-1-0.1-2,0.1-3c0.2-1,0.7-1.8,1.3-2.5
				C49.2,6.4,50,5.8,51,5.6C52.8,5,55,5.4,56.8,6.2c1.8,0.8,3.3,2.3,4.6,3.8c2.5,3.1,4.1,6.4,5.7,8.7C68.7,21.1,70.1,22.6,70.8,23.1
				z"
              />
            </g>
            <g>
              <path
                d="M75.4,22.6c-0.9,0.7-1.6,1-2,1.2c-0.4,0.2-0.4,0.3-0.1,0.4c0.3,0.1,1,0.1,1.9-0.2c0.9-0.3,2.1-0.9,3.2-1.9
				c1.1-1,2.2-2.4,3.1-4.1c0.9-1.6,1.7-3.4,2.7-5.1c1-1.7,2.2-3.4,3.8-5c1.5-1.6,3.3-3,5.3-3.8c1.9-0.7,4.3-0.7,6,0.3
				c1.7,1,2.7,3.1,2.7,5.3c0,1.1-0.2,2.2-0.6,3.2c-0.4,1-1,2-1.7,2.9c-1.5,1.8-3.3,3.2-5.3,4.3c-3.9,2.3-8,3.5-11.5,4
				c-3.5,0.5-6.4,0.4-8.2,0.3c-1.8-0.1-2.1,0.1-1.2,0.6c0.9,0.5,3.2,1.1,6.4,1.3c3.2,0.2,7.4-0.2,11.9-1.8c2.2-0.8,4.5-1.9,6.6-3.4
				c2.1-1.5,4.2-3.5,5.5-6.1c1.4-2.7,1.6-5.9,0.6-8.8c-0.5-1.4-1.5-2.8-2.7-3.8c-1.3-1-2.8-1.5-4.3-1.7c-3-0.4-5.9,0.7-8,2.2
				c-2.2,1.5-3.8,3.4-5.1,5.2c-1.4,1.8-2.4,3.8-3.1,5.5c-0.8,1.8-1.4,3.4-2,4.6C77.8,20.8,76.1,22,75.4,22.6z"
              />
            </g>
            <g>
              <path
                d="M72.8,24.9c1-0.8,0.4-1.2-0.8-1.4c-1.2-0.2-3-0.5-5-1.4c-2-0.8-3.9-2.3-5.5-3.7c-1.6-1.4-3-2.8-4-3.2
				c-1-0.4-1.1,0.3-0.4,1.8c0.6,1.4,2.1,3.5,4.1,5.2c1,0.9,2.2,1.7,3.5,2.2c1.2,0.6,2.5,0.9,3.7,1C70.7,25.7,72.4,25.2,72.8,24.9z"
              />
            </g>
            <g>
              <path
                d="M74.7,23.5c-1.3,0.6-0.9,1.1,0.7,1.5c1.6,0.3,4.5,0.2,7.4-1.1c2.9-1.2,5.6-3.5,7.1-5.9c1.6-2.4,2-4.8,1.7-6
				c-0.7-2.3-1.9,2.4-5.8,6.1c-1.9,1.8-4.4,3.3-6.6,4.1C77.1,23,75.2,23.3,74.7,23.5z"
              />
            </g>
            <g>
              <path
                d="M29.9,19.5c0.2-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.7,0.1-1.1c0.1-0.4,0.3-1,0.6-1.4c0.1-0.1,0.2-0.2,0.3-0.2
				c0.1,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.3-0.1,0.6-0.2,1-0.3c0.8-0.1,1.8,0.1,2.6,0.6c0.9,0.5,1.9,1.4,2.8,2.6
				c0.9,1.2,1.8,2.6,3,4.1c0.6,0.8,1.2,1.5,2,2.3c0.8,0.7,1.6,1.4,2.5,1.9c1.8,1.1,3.7,1.8,5.5,2.2c1.8,0.4,3.6,0.7,5.4,0.8
				c3.5,0.3,6.8,0,9.5-0.8c2.7-0.8,4.8-2,6-3.1c0.6-0.5,1.1-1,1.3-1.3c0.3-0.3,0.4-0.5,0.4-0.5s-0.2,0.1-0.5,0.4
				c-0.3,0.3-0.9,0.6-1.5,1c-1.4,0.8-3.5,1.6-6.1,2c-2.6,0.3-5.7,0.2-8.8-0.5c-3.2-0.7-6.5-1.7-9-3.6c-1.2-0.9-2.1-2-3-3.4
				c-0.9-1.4-1.7-2.9-2.8-4.4c-1.1-1.5-2.5-3-4.2-3.9c-1.8-1-3.8-1.3-5.7-0.9c-0.9,0.2-1.8,0.6-2.6,1.1c-0.4,0.3-0.7,0.6-1,0.9
				c-0.3,0.4-0.5,0.7-0.7,1.1c-0.7,1.5-0.6,2.9-0.2,4c0.4,1.1,1.1,1.7,1.7,1.8C29.3,20,29.7,19.8,29.9,19.5z"
              />
            </g>
            <g>
              <path
                d="M116.2,20c0.1,0.2,0.5,0.4,1.1,0.1c0.6-0.3,1.3-1,1.6-2.1c0.3-1.1,0.4-2.5-0.3-4c-0.2-0.4-0.4-0.8-0.7-1.1
				c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.3-0.3-0.5-0.4c-0.8-0.5-1.7-0.9-2.6-1.1c-1.9-0.4-3.9,0-5.7,1c-1.8,1-3.1,2.4-4.2,3.9
				c-1.1,1.5-2,3-2.9,4.4c-0.9,1.4-1.8,2.5-3,3.3c-2.4,1.8-5.8,2.8-9,3.4c-3.1,0.6-6.2,0.7-8.7,0.3c-2.5-0.4-4.5-1.2-5.8-2
				c-0.6-0.4-1.1-0.8-1.4-1c-0.3-0.3-0.5-0.4-0.5-0.4s0.1,0.2,0.4,0.5c0.3,0.3,0.7,0.8,1.2,1.3c1.2,1,3.1,2.3,5.8,3.1
				c2.6,0.9,5.9,1.2,9.4,1c1.7-0.1,3.5-0.3,5.4-0.7c1.8-0.4,3.7-1.1,5.5-2.1c0.9-0.5,1.7-1.2,2.5-1.9c0.8-0.7,1.4-1.5,2-2.2
				c1.2-1.5,2.1-3,3-4.1c0.9-1.2,1.9-2.1,2.8-2.6c0.9-0.5,1.9-0.7,2.6-0.6c0.4,0,0.7,0.1,1,0.2c0.1,0,0.1,0.1,0.2,0.1
				c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.4,0.6,1,0.8,1.5c0.1,0.5,0.1,0.9,0.1,1.4C116,19.2,116,19.6,116.2,20z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#009169"
              d="M123.4,68.3c-1.6-1.1-3.6-1.4-5.4-1.4c-2.6,0.1-5,1-7.5,1.5c-3,0.6-5.8,0.3-8.8-0.2c-0.3,0-0.7,0-0.8,0.3
			c-0.3,0.7-0.5,1.4-0.5,2c-1-0.6,1.1,2.8,1.8,4.1c1,1.7,2.9,2.8,4.6,3.8c3.5,2,7.8,3.1,11.8,2.5c4-0.5,7.6-3.6,7.4-7.9
			C126,71.2,125.1,69.4,123.4,68.3z"
            />
            <path
              fill="#F30202"
              d="M110.3,56.5c-0.6-0.9-1.3-1.7-2.1-2.3c-0.7-0.8-1.5-1.6-2.5-2.1c-3.9-2.1-9.1-1.5-12.3,1.3
			c-3.1,1.2-5.6,3.5-6.7,6.9c-1.8,5.2,1.3,11.5,7.2,12c2.4,0.2,4.8-1.1,6.6-2.7c1.2,0.2,2.3,0.4,3.5,0.1
			C110.2,68.9,114.1,62.2,110.3,56.5z"
            />
            <g>
              <path
                d="M99.6,61.3c-1-0.7-1.8-0.9-2.3-0.9c-0.4,0-0.5,0.1-0.3,0.3c0.2,0.2,0.7,0.5,1.2,1c0.5,0.5,1.2,1.4,1.6,2.5
				c0.4,1.1,0.6,2.6,0.1,4c-0.4,1.4-1.6,2.7-3.3,3.4c-1.7,0.7-3.8,0.8-5.6,0c-1.8-0.8-3.3-2.6-4-4.8c-0.7-2.2-0.5-4.5,0.6-6.7
				c1.1-2.2,2.9-4.1,5-5.4c2.1-1.4,4.5-2.3,6.9-2.6c2.4-0.2,4.8,0.3,6.7,1.5c1.9,1.2,3.3,3,3.9,4.9c0.6,1.9,0.3,4-0.4,5.6
				c-0.7,1.6-1.9,2.8-3.1,3.6c-1.2,0.8-2.4,1.2-3.4,1.4c-1,0.2-1.6,0.3-1.8,0.4c-0.2,0.1,0,0.3,0.6,0.4c0.6,0.1,1.6,0.2,2.9,0
				c1.3-0.2,2.8-0.8,4.4-2c1.5-1.2,2.9-3.1,3.4-5.5c0.3-1.2,0.4-2.5,0.2-3.8c-0.2-1.3-0.7-2.7-1.4-3.9c-1.5-2.4-3.9-4.3-6.7-5.2
				c-2.9-0.9-6-0.8-8.9,0.1c-2.9,0.9-5.5,2.4-7.7,4.6c-2.2,2.1-3.9,4.9-4.4,7.9c-0.5,3.1,0.3,6.2,2,8.6c0.8,1.2,1.9,2.2,3.1,2.9
				c1.2,0.7,2.6,1.1,3.9,1.2c2.6,0.2,5.1-0.8,6.8-2.2c1.7-1.5,2.6-3.6,2.6-5.3c0-1.8-0.5-3.2-1-4.2C100.6,62.2,100,61.6,99.6,61.3z"
              />
            </g>
            <g>
              <path
                d="M101,59.2c-0.1-0.4-0.3-0.5-0.6-0.4c-0.4,0.2-0.8,0.6-1.1,1.3c-0.3,0.6-0.4,1.4-0.2,2c0.1,0.6,0.5,1.1,0.9,1.2
				c0.7,0.2,0.5-0.7,0.6-1.7c0-0.5,0.1-1,0.2-1.5C100.9,59.8,101,59.4,101,59.2z"
              />
            </g>
            <g>
              <path
                d="M73.9,27.5c-0.8-1.7-0.9-1-0.4,1.2c0.5,2.2,1.6,5.8,3.4,9.6c1.7,3.8,4,7.8,6.4,11c2.3,3.2,4.5,5.6,5.7,6.5
				c2.4,1.8-2.5-3.7-6.8-10.8c-2.2-3.6-4.2-7.6-5.6-10.9C75.1,30.8,74.2,28.2,73.9,27.5z"
              />
            </g>
            <g>
              <path
                d="M102.1,70.4c-1.1-0.4-0.9,0,0.1,1c0.5,0.5,1.2,1.1,2.1,1.8c0.9,0.7,2.1,1.4,3.4,1.9c2.7,1,5.9,0.8,8.3-0.1
				c2.5-0.9,4-2.4,4.5-3.3c0.2-0.4,0.2-0.6-0.1-0.5c-0.3,0.1-0.7,0.4-1.3,0.8c-1.3,0.8-3.4,1.8-6,2c-2.5,0.3-5.2-0.3-7.2-1.4
				C104,71.7,102.6,70.6,102.1,70.4z"
              />
            </g>
            <g>
              <path
                d="M102,72.6c-1.1-1.3-1.5-1.7-1.6-1.2c0,0.5,0.3,1.8,1.4,3.6c1.1,1.8,3.1,3.9,6,5.6c1.5,0.8,3.1,1.5,5,1.8
				c1.8,0.4,3.9,0.4,5.9,0.1c2-0.4,4.1-1.2,5.8-2.6c1.7-1.4,3.1-3.4,3.6-5.7c0.2-1.1,0.2-2.3-0.1-3.5c-0.3-1.2-0.9-2.2-1.6-3
				c-1.5-1.7-3.5-2.6-5.5-2.9c-2-0.2-3.8,0.1-5.3,0.7c-1.6,0.6-2.8,1.5-3.9,2.1c-2.2,1.2-4.3,1.6-5.6,1.9c-1.3,0.3-1.6,0.5-0.8,0.8
				c0.7,0.3,2.5,0.6,5,0.1c1.2-0.2,2.6-0.8,3.9-1.4c1.3-0.6,2.4-1.1,3.8-1.3c1.3-0.2,2.8-0.1,4.1,0.5c1.2,0.6,2.4,1.6,2.8,2.9
				c0.5,1.2,0.3,2.8-0.4,4.2c-0.7,1.4-1.9,2.5-3.4,3.3c-1.5,0.8-3.1,1.2-4.7,1.3c-1.6,0.1-3.2-0.1-4.6-0.5c-2.9-0.8-5.3-2.3-6.8-3.6
				C103.3,74.3,102.4,73.1,102,72.6z"
              />
            </g>
            <path fill="#FF4949" d="M92.5,59.7c-3.8,0-3.8,6,0,6C96.3,65.7,96.4,59.7,92.5,59.7z" />
            <path fill="#FF4949" d="M95.8,66.5c-1.9,0-1.9,3,0,3C97.8,69.5,97.8,66.5,95.8,66.5z" />
          </g>
          <g>
            <path
              fill="#F30202"
              d="M57.4,34c-3.2-1.4-7.1-1.2-9.9,1.5c-4.6,4.5-3.3,11.7,1.6,14.8c0,0.2,0,0.4,0,0.6c0.2,4.5,3.4,8.3,7.8,9.1
			c4.6,0.8,8.3-2.2,9.9-6.3C69.8,46.2,66.4,34.3,57.4,34z"
            />
            <g>
              <path
                d="M54.6,43c1.1-0.6,2-0.8,2.4-1c0.5-0.2,0.5-0.3,0.2-0.4c-0.3-0.1-1.1-0.2-2.2,0c-1.1,0.2-2.5,0.7-3.8,1.8
				c-1.3,1.1-2.6,2.8-3.3,5.1c-0.7,2.3-0.3,5.2,1.3,7.5c1.5,2.3,4,4.2,7.1,4.9c3.1,0.7,6.6-0.2,9.2-2.3c1.3-1,2.4-2.3,3.2-3.8
				c0.4-0.7,0.8-1.5,1-2.3c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.4,0.1-0.8,0.2-1.2c0.4-3.2-0.1-6.6-1.6-9.6c-0.4-0.7-0.8-1.4-1.3-2.1
				c-0.2-0.3-0.5-0.6-0.8-0.9c-0.3-0.3-0.5-0.6-0.8-0.9c-1.1-1.1-2.3-2.1-3.7-2.9c-2.7-1.6-5.8-2.5-8.8-2.1c-3,0.3-5.6,1.8-7.3,3.8
				c-1.8,1.9-2.8,4.3-2.9,6.5c-0.1,2.2,0.7,4.1,1.6,5.4c1,1.3,2.1,2.1,3,2.4c0.9,0.4,1.5,0.3,1.7,0.2c0.2-0.1,0-0.3-0.4-0.5
				c-0.4-0.3-1-0.7-1.7-1.4c-0.7-0.7-1.4-1.8-1.8-3.2c-0.4-1.4-0.4-3,0.4-4.7c0.7-1.6,2.1-3.3,4-4.4c1.8-1.1,4.1-1.5,6.5-1
				c2.4,0.5,4.7,1.8,6.6,3.6c0.5,0.5,0.9,0.9,1.4,1.5c0.5,0.5,0.8,1,1.1,1.6c0.7,1.1,1.2,2.3,1.5,3.6c0.3,1.3,0.4,2.6,0.4,4
				c0,0.7-0.1,1.3-0.2,2c-0.1,0.6-0.3,1.2-0.6,1.8c-1,2.3-3,4.2-5.2,5.1c-2.2,0.9-4.7,0.7-6.7-0.3c-2-1-3.5-2.7-4.2-4.5
				c-0.7-1.8-0.6-3.7,0-5.1c0.5-1.5,1.5-2.6,2.2-3.3C53.4,43.6,54.2,43.2,54.6,43z"
              />
            </g>
            <g>
              <path
                d="M54.8,39.3c0.1-0.4,0-0.6-0.5-0.5c-0.5,0.1-1.2,0.5-1.6,1.2c-0.5,0.7-0.7,1.7-0.6,2.4c0.1,0.8,0.5,1.3,0.9,1.4
				c0.8,0.1,0.4-0.8,0.6-1.9c0.1-0.6,0.3-1.2,0.6-1.7C54.5,39.8,54.8,39.4,54.8,39.3z"
              />
            </g>
            <g>
              <path
                d="M73.9,24.8c-0.9-2-0.5,1.7-1.4,6.1c-0.5,2.2-1.3,4.6-2.2,6.5c-0.5,1-0.9,1.8-1.3,2.6c-0.4,0.7-0.8,1.3-0.8,1.7
				c0.1,0.4,0.3,0.1,0.3,0.2c0.2,0,0.1,0,0.3-0.1c0.1-0.1,0.4-0.4,0.6-0.6c1-1.1,2.3-3,3.3-5.3c0.5-1.1,0.9-2.4,1.1-3.6
				c0.3-1.2,0.4-2.4,0.5-3.4C74.3,26.8,74.1,25.2,73.9,24.8z"
              />
            </g>
            <g>
              <path
                fill="#009169"
                d="M42.7,49.1c-3.7-2.6-7.5-5.2-11.3-7.8c-3.1-2.1-6.7-5-10.6-3.2c-3.3,1.5-4.6,5.6-2.7,8.7
				c0.9,1.6,2.5,2.5,4.2,3.1c1.9,0.7,4,1,6,1.3c4.8,0.6,9.8,0.3,14.5-0.8C43.7,50.2,43.4,49,42.7,49.1z"
              />
              <g>
                <path
                  d="M48.3,49.4c1.1-0.6,0.5-0.7-0.8-0.5c-1.4,0.1-3.6,0.4-6.1,0.3c-2.5-0.1-5.2-0.5-7.5-1.2c-2.3-0.6-4.1-1.4-5.1-1.7
					c-1-0.2-0.5,0.3,0.9,1.2c1.4,0.9,3.7,2,6.4,2.6c2.7,0.6,5.6,0.7,7.9,0.4C46.3,50.2,47.9,49.7,48.3,49.4z"
                />
              </g>
              <g>
                <path
                  d="M45,49.9c1.1-0.2,1.7-0.6,1.9-0.9c0.2-0.3,0.2-0.4-0.1-0.4c-0.5,0-1.8,0.4-3.7-0.6c-0.9-0.4-1.9-1.2-2.9-2.3
					c-1-1.1-2.3-2.4-3.8-3.7c-1.5-1.3-3.1-2.6-5-3.8c-1.9-1.2-4.2-2.3-6.8-2.6c-2.7-0.3-5.6,0.5-7.7,2.6c-1.1,1-1.9,2.4-2.1,3.9
					c-0.3,1.5,0,3.1,0.6,4.4c0.6,1.3,1.5,2.4,2.5,3.3c1,0.9,2.2,1.5,3.4,2c2.4,0.9,4.7,1.2,6.8,1.4c4.3,0.4,8.3,0.2,11.6-0.5
					c3.2-0.7,5.6-1.9,6.9-2.9c1.3-1,1.3-1.3,0.4-1.1c-0.8,0.2-2.6,0.9-5.1,1.4c-2.5,0.5-5.9,0.8-9.8,0.5c-1.9-0.1-4-0.4-6.1-0.7
					c-2-0.4-4-1-5.6-2.1c-1.5-1.1-2.6-2.9-2.6-4.6c0-1.7,1.3-3.2,3-4c0.9-0.4,1.8-0.6,2.8-0.6c1,0,1.9,0.2,2.9,0.4
					c1.9,0.6,3.7,1.6,5.3,2.7c1.6,1.1,3.1,2.2,4.3,3.3c1.3,1.1,2.4,2.2,3.5,3c1.1,0.9,2.2,1.4,3.2,1.7C43.9,50,44.6,50,45,49.9z"
                />
              </g>
            </g>
            <path fill="#FF4949" d="M60.6,45.1c-3.8,0-3.8,6,0,6C64.4,51,64.4,45.1,60.6,45.1z" />
            <path fill="#FF4949" d="M57.6,52.2c-1.9,0-1.9,3,0,3C59.5,55.2,59.5,52.2,57.6,52.2z" />
          </g>
        </g>
      </svg>
    </Box>
  )
}
